/** @format */

import React from "react";
import { BsArrowLeft } from "react-icons/bs";

const PaymentSummary = ({
    total,
    sumTotal,
    currency,
    vat,
    merchant,
    setIsProduct,
    shouldOnlyAllowPayment,
    shouldModifyAmount,
    merchantDetails,
    fees,
}) => {
    const formatAmount = (amount) => {
        // if (amount === 0 || typeof amount !== "number")
        if (Number(amount).toFixed(2) !== "NaN")
            return `${currency?.symbol || ''}${Number(amount).toFixed(2)}`;
        else return `${currency?.symbol || ''}0.00`;
    };

    const item = [
        {
            title:
                merchantDetails?.ent_type === "RELIGIOUS" ? "Give to" : "Pay",
            value: merchant,
        },
        { title: "Amount", value: formatAmount(total) },
        { title: "Fees", value: formatAmount(fees) },
    ];

    let vatHolder = { title: "VAT", value: formatAmount(vat) };
    if (merchantDetails?.ent_type !== "RELIGIOUS") {
        item.push(vatHolder);
    }

    return (
        <div className="w-full bg-white">
            <div className="bg-[#A4A4A4] w-full h-[50px] text-white justify-start px-4 flex items-center font-bold">
                {setIsProduct && shouldModifyAmount && (
                    <div
                        className="mr-2 cursor-pointer flex md:hidden"
                        onClick={() => {
                            setIsProduct(true);
                        }}>
                        <BsArrowLeft />
                    </div>
                )}
                {merchantDetails?.ent_type === "RELIGIOUS"
                    ? "Giving "
                    : "Payment "}
                Summary
            </div>

            <div className="flex flex-col gap-2 px-3 py-10">
                {item.map((i, index) => {
                    return (
                        <div key={index} className="flex flex-row justify-between items-center text-xs">
                            <span className="text-[#777777]">
                                {i?.title ?? "-"}
                            </span>
                            <span className="font-semibold text-[#031339]">
                                {i?.value ?? "-"}
                            </span>
                        </div>
                    );
                })}
            </div>

            <div className="w-full h-[1px] bg-[#DADADA]" />

            <div className="flex flex-col gap-2 px-3 py-3">
                <div className="flex flex-row justify-between items-center text-xs">
                    <span className="text-[#777777]">Total</span>
                    <span className="text-[#031339] font-bold text-base">
                        {formatAmount(sumTotal) || 0}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default PaymentSummary;
